import { create } from "zustand";

interface AICommentsState {
  aiComments: any[];
  setAIComments: (comments: any[]) => void;
  getReproductionSteps: () => string;
}

export const useAICommentsStore = create<AICommentsState>((set, get) => ({
  aiComments: [],

  setAIComments: (comments) => {
    set({ aiComments: comments });
  },

  getReproductionSteps: () => {
    const { aiComments } = get();

    if (!aiComments || aiComments.length === 0) return "";

    // Find the comment with isReproductionSteps flag
    const reproductionStepComment = aiComments.find(
      (comment: any) => comment.isReproductionSteps === true
    );

    if (!reproductionStepComment) return "";

    // Return with prefix for task manager modals
    return `Reproduction steps:\n\n${reproductionStepComment.text}`;
  },
}));
